(() => {
  if (window.__scwSoccerPriceBands) return;
  window.__scwSoccerPriceBands = true;
  const bands = [
    ['£1,000+', 100000, Infinity], ['£500–£999.99', 50000, 100000],
    ['£250–£499.99', 25000, 50000], ['£100–£249.99', 10000, 25000], ['Under £100', 0, 10000]
  ];
  const el = (tag, cls, content) => { const node = document.createElement(tag); node.className = cls; if (content !== undefined) node.textContent = content; return node; };
  const refreshCardImages = card => {
    card.querySelectorAll('img').forEach(image => {
      // Safari can leave responsive images blank after cards are parsed off-page,
      // moved between grids, restored from bfcache, or reinserted on expansion.
      // Use one concrete Shopify CDN URL for dynamically managed cards instead
      // of carrying the detached element's srcset/sizes selection state forward.
      let directSource = image.currentSrc || image.getAttribute('src') || '';
      // Detached cards can retain a tiny fallback thumbnail. Request enough CDN
      // pixels for this grid and screen density, while retaining native lazy loading.
      if (directSource) {
        const gridWidth = document.getElementById('product-grid')?.getBoundingClientRect().width || window.innerWidth;
        const columns = window.innerWidth < 750 ? 2 : 4;
        const targetWidth = Math.min(1200, Math.ceil((gridWidth / columns) * Math.min(window.devicePixelRatio || 1, 2) / 100) * 100);
        const url = new URL(directSource, location.href);
        if (url.pathname.includes('/products/') || url.pathname.includes('/files/')) {
          url.searchParams.set('width', String(targetWidth));
          directSource = url.href;
        }
      }
      if (!directSource) return;
      const fresh = document.createElement('img');
      for (const {name, value} of image.attributes) {
        if (!['src', 'srcset', 'sizes', 'loading'].includes(name)) fresh.setAttribute(name, value);
      }
      fresh.loading = 'lazy';
      fresh.decoding = 'async';
      fresh.dataset.scwRevealedImage = 'true';
      fresh.src = directSource;
      image.replaceWith(fresh);
    });
  };
  let active;
  async function enhance() {
    const grid = document.querySelector('#product-grid[data-scw-price-bands="true"]');
    if (!grid || grid.dataset.scwBandsState) return;
    if (active) active.abort();
    const controller = new AbortController(); active = controller;
    grid.dataset.scwBandsState = 'loading';
    const collection = grid.closest('.collection');
    const status = collection.querySelector('.scw-bands-initial') || el('p', 'scw-bands-loading', 'Loading products by price…');
    status.setAttribute('role', 'status'); grid.before(status);
    try {
      const pages = Number(grid.dataset.scwPages), current = Number(grid.dataset.scwPage);
      if (!pages || pages > 100) throw new Error('Invalid page count');
      const cards = [...grid.querySelectorAll(':scope > [data-scw-product-card]')];
      // Fetch every matching page before grouping so band counts and price order are complete.
      for (let page = 1; page <= pages; page++) {
        if (page === current) continue;
        const url = new URL(location.href); url.hash = '';
        url.searchParams.set('section_id', grid.dataset.id); url.searchParams.set('page', String(page));
        const response = await fetch(url, { signal: controller.signal });
        if (!response.ok) throw new Error('Collection page unavailable');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const nextGrid = doc.querySelector('#product-grid[data-scw-price-bands="true"]');
        if (!nextGrid || Number(nextGrid.dataset.scwPages) !== pages) throw new Error('Collection changed during load');
        cards.push(...nextGrid.querySelectorAll(':scope > [data-scw-product-card]'));
      }
      if (!grid.isConnected || controller.signal.aborted) return;
      // Deferred cards retain product links and prices for no-JS/error fallback.
      // Fetch their full markup only after a shopper expands a band.
      let availableCardsPromise;
      const loadAvailableCards = () => {
        if (!availableCardsPromise) availableCardsPromise = (async () => {
          const loaded = new Map();
          let pageCount = 1;
          for (let page = 1; page <= pageCount; page++) {
            const url = new URL(location.href); url.hash = '';
            url.searchParams.set('section_id', 'scw-deferred-price-band-cards');
            url.searchParams.set('filter.v.availability', '1');
            url.searchParams.set('page', String(page));
            const response = await fetch(url, {signal: controller.signal});
            if (!response.ok) throw new Error('Cards unavailable');
            const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
            const root = doc.querySelector('[data-scw-deferred-cards]');
            pageCount = Number(root?.dataset.pages);
            if (!pageCount || pageCount > 100) throw new Error('Invalid card response');
            root.querySelectorAll('[data-scw-product-card]').forEach(card => loaded.set(card.dataset.scwProductId, card));
          }
          return loaded;
        })().catch(error => { availableCardsPromise = null; throw error; });
        return availableCardsPromise;
      };
      const ids = new Set(cards.map(c => c.dataset.scwProductId));
      if (ids.size !== cards.length || cards.length !== Number(grid.dataset.scwProductCount) || cards.some(c => !c.dataset.scwProductId || !Number.isFinite(Number(c.dataset.scwProductPrice)))) throw new Error('Incomplete product list');
      // Format navigation stays within the existing price-band collection.
      const boxFilter = new URL(location.href).searchParams.get('scw_box');
      const boxLabels = {hobby:'Hobby Boxes',mega:'Mega Boxes',blaster:'Blaster Boxes',other:'Other Boxes'};
      const formatFor = card => {
        const title = (card.dataset.scwProductTitle || card.querySelector('a')?.textContent || '').toLowerCase();
        if (/\bcase\b/.test(title)) return 'other';
        if (/\bmega\b/.test(title)) return 'mega';
        if (/\bblaster\b/.test(title)) return 'blaster';
        if (/\bhobby\b/.test(title) && /\bbox\b/.test(title)) return 'hobby';
        return /\bbox\b/.test(title) ? 'other' : '';
      };
      if (boxLabels[boxFilter] && location.pathname === '/collections/soccer-cards-stock') {
        const matching = cards.filter(card => formatFor(card) === boxFilter);
        // Filtering can promote deferred cards into the first visible row.
        const firstRows = bands.flatMap(([,min,max]) => matching.filter(c => c.dataset.scwProductAvailable === 'true' && Number(c.dataset.scwProductPrice) >= min && Number(c.dataset.scwProductPrice) < max).sort((a,b)=>Number(b.dataset.scwProductPrice)-Number(a.dataset.scwProductPrice)).slice(0,4));
        if (firstRows.some(c => c.dataset.scwDeferred === 'true')) {
          const loaded = await loadAvailableCards();
          firstRows.forEach(card => {
            if (card.dataset.scwDeferred !== 'true') return;
            const full=loaded.get(card.dataset.scwProductId);
            if (!full) throw new Error('Filtered product unavailable');
            full.dataset.scwProductTitle=card.dataset.scwProductTitle;
            matching[matching.indexOf(card)]=full;
          });
        }
        cards.splice(0,cards.length,...matching);
        grid.dataset.scwHeading = 'Soccer ' + boxLabels[boxFilter];
        document.querySelectorAll('.scw-collection-menu__link').forEach(link => {
          if (new URL(link.href).searchParams.get('scw_box') === boxFilter) link.setAttribute('aria-current','page');
        });
        document.querySelectorAll('facet-filters-form form').forEach(form => {
          if (!form.querySelector('[name="scw_box"]')) {
            const input=document.createElement('input'); input.type='hidden'; input.name='scw_box'; input.value=boxFilter; form.append(input);
          }
        });
      }
      const showAllCards = ['soccer-cards-stock','soccer-hobby-boxes','panini','topps','daka','upper-deck','futera','soccer-presale'].includes(location.pathname.split('/').filter(Boolean).pop());
      if (showAllCards && cards.some(card => card.dataset.scwProductAvailable === 'true' && card.dataset.scwDeferred === 'true')) {
        const loaded = await loadAvailableCards();
        if (!grid.isConnected || controller.signal.aborted) return;
        cards.forEach((card,index) => {
          if (card.dataset.scwProductAvailable !== 'true' || card.dataset.scwDeferred !== 'true') return;
          const full = loaded.get(card.dataset.scwProductId);
          if (!full) throw new Error('Product list changed');
          full.dataset.scwProductTitle = card.dataset.scwProductTitle;
          cards[index] = full;
        });
      }
      cards.sort((a,b) => Number(b.dataset.scwProductPrice) - Number(a.dataset.scwProductPrice));
      const available = cards.filter(c => c.dataset.scwProductAvailable === 'true');
      const sold = cards.filter(c => c.dataset.scwProductAvailable !== 'true');
      const intro = el('div', 'scw-bands-intro');
      const heading = el('div', 'scw-bands-heading');
      heading.append(el('h1', '', grid.dataset.scwHeading || 'Soccer cards'), el('span', 'scw-bands-order', 'Price: high to low ↓'));
      intro.append(heading, el('p', 'scw-bands-count', `${available.length} available products · Browse by budget`));
      const jumps = el('nav', 'scw-bands-jumps'); jumps.setAttribute('aria-label','Jump to a price band'); intro.append(jumps);
      const fragment = document.createDocumentFragment();
      function addCards(parent, items, key) {
        const list = el('ul', 'scw-band-cards grid product-grid'); list.id = `scw-band-products-${key}`; list.setAttribute('role','list');
        items.forEach((card,index) => {
          card.classList.remove('scroll-trigger','animate--slide-in'); card.classList.add('scw-band-card');
          card.hidden = false;
          if (showAllCards || index < 4) {
            refreshCardImages(card);
            list.append(card);
          }
        });
        parent.append(list);
        if (!showAllCards && items.length > 4) {
          const button = el('button', 'scw-band-more', `View all ${items.length} products`);
          button.type = 'button'; button.setAttribute('aria-expanded','false'); button.setAttribute('aria-controls',list.id);
          button.addEventListener('click', async () => {
            const expanded = button.getAttribute('aria-expanded') !== 'true';
            if (expanded && items.slice(4).some(card => card.dataset.scwDeferred === 'true')) {
              button.disabled = true; button.textContent = 'Loading products…';
              try {
                const loaded = await loadAvailableCards();
                if (!grid.isConnected || controller.signal.aborted) return;
                const replacements = items.map(card => {
                  if (card.dataset.scwDeferred !== 'true') return card;
                  const full = loaded.get(card.dataset.scwProductId);
                  if (!full) throw new Error('Product list changed');
                  full.classList.add('scw-band-card'); return full;
                });
                items.splice(0, items.length, ...replacements);
              } catch (error) {
                if (controller.signal.aborted) return;
                button.textContent = 'Could not load — try again';
                return;
              } finally { button.disabled = false; }
            }
            items.slice(4).forEach(card => {
              if (!expanded) { card.remove(); return; }
              refreshCardImages(card);
              list.append(card);
            });
            button.setAttribute('aria-expanded',String(expanded)); button.textContent = expanded ? 'Show fewer products' : `View all ${items.length} products`;
          }); parent.append(button);
        }
      }
      bands.forEach(([label,min,max],index) => {
        const items = available.filter(c => Number(c.dataset.scwProductPrice) >= min && Number(c.dataset.scwProductPrice) < max);
        if (!items.length) return;
        const item = el('li', 'scw-price-band'); item.id = `scw-price-band-${index}`;
        const title = el('div', 'scw-band-title'); title.append(el('h2','',label),el('span','',`${items.length} ${items.length === 1 ? 'product' : 'products'}`));
        item.append(title); addCards(item,items,String(index)); fragment.append(item);
        const link = el('a','',label); link.href = `#${item.id}`; jumps.append(link);
      });
      if (!available.length) fragment.append(el('li','scw-bands-empty','No available products match these filters.'));
      if (sold.length) {
        const item = el('li','scw-price-band scw-sold-out');
        const details = el('details',''); const summary = el('summary','',`Sold out (${sold.length} products)`);
        details.append(summary);
        const loading = el('p', '', 'Open to load sold-out products.'); details.append(loading);
        let loadingSold = false, loadedSold = false;
        details.addEventListener('toggle', async () => {
          if (!details.open || loadingSold || loadedSold) return;
          loadingSold = true; loading.textContent = 'Loading sold-out products…';
          try {
            const requestedIds = new Set(sold.map(card => card.dataset.scwProductId));
            const loaded = new Map();
            let pageCount = 1;
            for (let page = 1; page <= pageCount; page++) {
              const url = new URL(location.href); url.hash = '';
              url.searchParams.set('section_id', 'scw-deferred-price-band-cards');
              url.searchParams.set('filter.v.availability', '0'); url.searchParams.set('page', String(page));
              const response = await fetch(url, {signal:controller.signal});
              if (!response.ok) throw new Error('Cards unavailable');
              const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
              const root = doc.querySelector('[data-scw-deferred-cards]');
              pageCount = Number(root?.dataset.pages);
              if (!pageCount || pageCount > 100) throw new Error('Invalid card response');
              root.querySelectorAll('[data-scw-product-card]').forEach(card => {
                if (requestedIds.has(card.dataset.scwProductId)) loaded.set(card.dataset.scwProductId, card);
              });
            }
            if (!grid.isConnected || controller.signal.aborted) return;
            if (loaded.size !== requestedIds.size) throw new Error('Product list changed');
            addCards(details, sold.map(card => loaded.get(card.dataset.scwProductId)), 'sold-out');
            loadedSold = true; loading.remove();
          } catch (error) {
            if (controller.signal.aborted) return;
            loading.textContent = 'Full cards could not load. Browse the product links below.';
            if (!details.querySelector('.scw-band-cards')) addCards(details, sold, 'sold-out');
            loadedSold = true;
          } finally { loadingSold = false; }
        });
        item.append(details); fragment.append(item);
      }
      grid.replaceChildren(fragment); grid.before(intro);
      collection.querySelectorAll('.pagination-wrapper').forEach(n => n.hidden = true);
      status.remove(); grid.dataset.scwBandsState = 'ready';
      grid.dispatchEvent(new CustomEvent('scw:price-bands-ready', {bubbles:true}));
    } catch (error) {
      if (controller.signal.aborted || !grid.isConnected) return;
      grid.dataset.scwBandsState = 'fallback';
      status.textContent = 'Price groups could not load. You can still browse the products below.';
      console.warn('Soccer price bands:',error.message);
    }
  }
  function start() {
    const container = document.getElementById('ProductGridContainer'); if (!container) return;
    new MutationObserver(enhance).observe(container,{childList:true,subtree:true}); enhance();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',start); else start();
  window.addEventListener('pageshow', event => {
    if (!event.persisted) return;
    document.querySelectorAll('.scw-band-card').forEach(card => refreshCardImages(card));
  });
})();
